export default __webpack_public_path__ + "static/media/ukana-logo2.4da7d8ca.png";